import React from "react";
import { connect } from "react-redux";

import {
  deleteFeaturedMan,
  addFeaturedMan,
} from "../../../redux/actions/featuredManufacturers";
import styles from "../../../styles/Components/Shared/ConfirmForm.module.css";

const ReplaceOrCancelDialog = ({
  deleteFeaturedMan,
  addFeaturedMan,
  newManu,
  replacementManufacturer,
  open,
  handleClose,
}) => {
  const handleSubmit = (e) => {
    deleteFeaturedMan(replacementManufacturer[0].feature_manufacturer_id);
    addFeaturedMan(newManu);
    handleClose(e, 'submitted');
  };
  return (
    <div className={styles.confirm_modal_container}>
        <p className={styles.confirm_modal_header}>REPLACE FEATURED MANUFACTURER PRODUCTS</p>
        <div>
            <p className={styles.confirm_modal_text}>A set of featured products already exist for this manufacturer. Would you like to
          replace the set?</p>
        </div>
        <div className={styles.confirm_modal_button_container}>
            <button  className={styles.confirm_modal_buttons} onClick={handleClose}>No</button>
            <button  className={styles.confirm_modal_buttons} onClick={handleSubmit}>Yes</button>
        </div>
    </div>
    
  );
};

const mapStateToProps = (state) => ({
  featuredManufacturer: state.featuredManufacturer,
});

export default connect(mapStateToProps, { deleteFeaturedMan, addFeaturedMan })(
  ReplaceOrCancelDialog
);
